import type { AIDefinitionsPluginOptions } from '@atlassian/editor-plugin-ai-definitions/types';

interface Props {
	options: AIDefinitionsPluginOptions;
}

export function aiDefinitionsPluginOptions({ options }: Props): AIDefinitionsPluginOptions {
	// Options not declared here as they are all nested inside hooks, starting with `useEditorPluginAIDefinitionsConfig`.
	return options;
}
